import React, { FunctionComponent } from 'react';
import nexarLogoUrl from '../../assets/images/nexar-primary-lockup-white-rgb-100-px.png';
import './page-footer.scss';

interface Props {
}

const PageFooter: FunctionComponent<Props> = ({}) => {
  return (
    <footer className="site-footer">
      <img className="logo" src={nexarLogoUrl} alt="Nexar" draggable={false} />
        <div>© {new Date().getFullYear()}, Nexar All Rights Reserved</div>
      </footer>
  );
};

export default PageFooter;
